// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/editor/v1/editor.proto" (package "c1.api.editor.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message c1.api.editor.v1.EditorMarker
 */
export interface EditorMarker {
    /**
     * @generated from protobuf field: int32 startLineNumber = 1
     */
    startLineNumber: number;
    /**
     * @generated from protobuf field: int32 startColumn = 2
     */
    startColumn: number;
    /**
     * @generated from protobuf field: int32 endLineNumber = 3
     */
    endLineNumber: number;
    /**
     * @generated from protobuf field: int32 endColumn = 4
     */
    endColumn: number;
    /**
     * @generated from protobuf field: string message = 5
     */
    message: string;
    /**
     * @generated from protobuf field: c1.api.editor.v1.EditorMarkerSeverity severity = 6
     */
    severity: EditorMarkerSeverity;
}
/**
 * @generated from protobuf message c1.api.editor.v1.EditorServiceValidateCELRequest
 */
export interface EditorServiceValidateCELRequest {
    /**
     * @generated from protobuf field: string expression = 1
     */
    expression: string;
    /**
     * @generated from protobuf field: c1.api.editor.v1.EditorValidationEnv validation_env = 2
     */
    validationEnv: EditorValidationEnv;
    /**
     * Form field context for FORM_FIELD environment.
     *
     * @generated from protobuf field: c1.api.editor.v1.FormFieldCELContext form_field_context = 3
     */
    formFieldContext?: FormFieldCELContext;
    /**
     * Workflow context for WORKFLOW_STEP and WORKFLOW_TRIGGER environments.
     *
     * @generated from protobuf field: c1.api.editor.v1.WorkflowCELContext workflow_context = 4
     */
    workflowContext?: WorkflowCELContext;
}
/**
 * @generated from protobuf message c1.api.editor.v1.EditorServiceValidateCELResponse
 */
export interface EditorServiceValidateCELResponse {
    /**
     * @generated from protobuf field: repeated c1.api.editor.v1.EditorMarker markers = 2
     */
    markers: EditorMarker[];
}
/**
 * WorkflowCELContext provides context for workflow-related CEL validation.
 * This allows the schema to include step output variables dynamically.
 *
 * @generated from protobuf message c1.api.editor.v1.WorkflowCELContext
 */
export interface WorkflowCELContext {
    /**
     * The trigger type for the workflow (maps to workflow trigger type enum value).
     *
     * @generated from protobuf field: int32 trigger_type = 1
     */
    triggerType: number;
    /**
     * Names of preceding steps whose outputs are available.
     *
     * @generated from protobuf field: repeated string preceding_step_names = 2
     */
    precedingStepNames: string[];
    /**
     * The name of the current step being edited.
     *
     * @generated from protobuf field: string current_step_name = 3
     */
    currentStepName: string;
}
/**
 * FormFieldCELContext provides context for form field CEL validation.
 * This allows the schema to include the fields variable with proper field types.
 *
 * @generated from protobuf message c1.api.editor.v1.FormFieldCELContext
 */
export interface FormFieldCELContext {
    /**
     * The form fields available in this context.
     * Each entry maps field name to its type (e.g., "string", "bool", "list(string)").
     * Type values are not further constrained since they come from FieldToCELType mappings.
     *
     * @generated from protobuf field: map<string, string> field_types = 1
     */
    fieldTypes: {
        [key: string]: string;
    };
    /**
     * The name of the current field being edited (optional, empty string is valid).
     * When provided, the "value" variable will be typed according to this field's type.
     * When not provided or empty, "value" defaults to string type.
     *
     * @generated from protobuf field: string current_field_name = 2
     */
    currentFieldName: string;
}
/**
 * @generated from protobuf message c1.api.editor.v1.EditorServiceGetCELSchemaRequest
 */
export interface EditorServiceGetCELSchemaRequest {
    /**
     * The validation environment to get the schema for.
     *
     * @generated from protobuf field: c1.api.editor.v1.EditorValidationEnv validation_env = 1
     */
    validationEnv: EditorValidationEnv;
    /**
     * Workflow context for WORKFLOW_STEP and WORKFLOW_TRIGGER environments.
     *
     * @generated from protobuf field: c1.api.editor.v1.WorkflowCELContext workflow_context = 2
     */
    workflowContext?: WorkflowCELContext;
    /**
     * Form field context for FORM_FIELD environment.
     *
     * @generated from protobuf field: c1.api.editor.v1.FormFieldCELContext form_field_context = 3
     */
    formFieldContext?: FormFieldCELContext;
}
/**
 * @generated from protobuf message c1.api.editor.v1.EditorServiceGetCELSchemaResponse
 */
export interface EditorServiceGetCELSchemaResponse {
    /**
     * Available variables in this CEL environment.
     *
     * @generated from protobuf field: repeated c1.api.editor.v1.CELVariable variables = 1
     */
    variables: CELVariable[];
    /**
     * Available functions in this CEL environment.
     *
     * @generated from protobuf field: repeated c1.api.editor.v1.CELFunction functions = 2
     */
    functions: CELFunction[];
    /**
     * Available types in this CEL environment.
     *
     * @generated from protobuf field: repeated c1.api.editor.v1.CELType types = 3
     */
    types: CELType[];
    /**
     * Available constants in this CEL environment (e.g., TimeFormat.RFC3339).
     *
     * @generated from protobuf field: repeated c1.api.editor.v1.CELConstant constants = 4
     */
    constants: CELConstant[];
}
/**
 * CELVariable describes a variable available in a CEL environment.
 *
 * @generated from protobuf message c1.api.editor.v1.CELVariable
 */
export interface CELVariable {
    /**
     * The name of the variable (e.g., "subject", "task", "ctx").
     *
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * The type name of the variable (e.g., "c1.user.v1", "c1.task.v1").
     *
     * @generated from protobuf field: string type_name = 2
     */
    typeName: string;
    /**
     * Human-readable description of the variable.
     *
     * @generated from protobuf field: string description = 3
     */
    description: string;
}
/**
 * CELFunction describes a function available in a CEL environment.
 *
 * @generated from protobuf message c1.api.editor.v1.CELFunction
 */
export interface CELFunction {
    /**
     * The fully qualified function name (e.g., "c1.user.v1.HasEntitlement").
     *
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * Human-readable description of the function.
     *
     * @generated from protobuf field: string description = 2
     */
    description: string;
    /**
     * Parameter types in order.
     *
     * @generated from protobuf field: repeated string param_types = 3
     */
    paramTypes: string[];
    /**
     * Return type of the function.
     *
     * @generated from protobuf field: string return_type = 4
     */
    returnType: string;
}
/**
 * CELType describes a custom type available in a CEL environment.
 *
 * @generated from protobuf message c1.api.editor.v1.CELType
 */
export interface CELType {
    /**
     * The type name (e.g., "c1.user.v1").
     *
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * Human-readable description of the type.
     *
     * @generated from protobuf field: string description = 2
     */
    description: string;
    /**
     * Fields available on this type.
     *
     * @generated from protobuf field: repeated c1.api.editor.v1.CELTypeField fields = 3
     */
    fields: CELTypeField[];
}
/**
 * CELTypeField describes a field on a CEL type.
 *
 * @generated from protobuf message c1.api.editor.v1.CELTypeField
 */
export interface CELTypeField {
    /**
     * The field name (e.g., "email", "department").
     *
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * The type of the field (e.g., "string", "int", "list(string)").
     *
     * @generated from protobuf field: string type_name = 2
     */
    typeName: string;
    /**
     * Human-readable description of the field.
     *
     * @generated from protobuf field: string description = 3
     */
    description: string;
}
/**
 * CELConstant describes a constant available in a CEL environment.
 *
 * @generated from protobuf message c1.api.editor.v1.CELConstant
 */
export interface CELConstant {
    /**
     * The constant name (e.g., "TimeFormat.RFC3339").
     *
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * The type of the constant value.
     *
     * @generated from protobuf field: string type_name = 2
     */
    typeName: string;
    /**
     * The string representation of the value.
     *
     * @generated from protobuf field: string value = 3
     */
    value: string;
    /**
     * Human-readable description of the constant.
     *
     * @generated from protobuf field: string description = 4
     */
    description: string;
}
/**
 * @generated from protobuf enum c1.api.editor.v1.EditorMarkerSeverity
 */
export enum EditorMarkerSeverity {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: HINT = 1;
     */
    HINT = 1,
    /**
     * @generated from protobuf enum value: INFO = 2;
     */
    INFO = 2,
    /**
     * @generated from protobuf enum value: WARNING = 4;
     */
    WARNING = 4,
    /**
     * @generated from protobuf enum value: ERROR = 8;
     */
    ERROR = 8
}
/**
 * @generated from protobuf enum c1.api.editor.v1.EditorValidationEnv
 */
export enum EditorValidationEnv {
    /**
     * @generated from protobuf enum value: EDITOR_VALIDATION_ENV_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: EDITOR_VALIDATION_ENV_POLICY = 1;
     */
    POLICY = 1,
    /**
     * @generated from protobuf enum value: EDITOR_VALIDATION_ENV_DIRECTORY = 2;
     */
    DIRECTORY = 2,
    /**
     * @generated from protobuf enum value: EDITOR_VALIDATION_ENV_POLICY_APPROVER = 3;
     */
    POLICY_APPROVER = 3,
    /**
     * @generated from protobuf enum value: EDITOR_VALIDATION_ENV_WORKFLOW_STEP = 4;
     */
    WORKFLOW_STEP = 4,
    /**
     * @generated from protobuf enum value: EDITOR_VALIDATION_ENV_WORKFLOW_TRIGGER = 5;
     */
    WORKFLOW_TRIGGER = 5,
    /**
     * @generated from protobuf enum value: EDITOR_VALIDATION_ENV_PUSH_RULE = 6;
     */
    PUSH_RULE = 6,
    /**
     * @generated from protobuf enum value: EDITOR_VALIDATION_ENV_ACCESS_REVIEW_USER = 7;
     */
    ACCESS_REVIEW_USER = 7,
    /**
     * @generated from protobuf enum value: EDITOR_VALIDATION_ENV_ACCESS_REVIEW_ACCOUNT = 8;
     */
    ACCESS_REVIEW_ACCOUNT = 8,
    /**
     * @generated from protobuf enum value: EDITOR_VALIDATION_ENV_ACCOUNT_PROVISIONING = 9;
     */
    ACCOUNT_PROVISIONING = 9,
    /**
     * @generated from protobuf enum value: EDITOR_VALIDATION_ENV_CONNECTOR_TRANSFORM = 10;
     */
    CONNECTOR_TRANSFORM = 10,
    /**
     * @generated from protobuf enum value: EDITOR_VALIDATION_ENV_ATTRIBUTE_MAPPING = 11;
     */
    ATTRIBUTE_MAPPING = 11,
    /**
     * @generated from protobuf enum value: EDITOR_VALIDATION_ENV_MANAGER_MAPPING = 12;
     */
    MANAGER_MAPPING = 12,
    /**
     * @generated from protobuf enum value: EDITOR_VALIDATION_ENV_DIRECTORY_STATUS = 13;
     */
    DIRECTORY_STATUS = 13,
    /**
     * @generated from protobuf enum value: EDITOR_VALIDATION_ENV_FORM_FIELD = 14;
     */
    FORM_FIELD = 14,
    /**
     * @generated from protobuf enum value: EDITOR_VALIDATION_ENV_DYNAMIC_GROUP_MEMBERSHIP = 15;
     */
    DYNAMIC_GROUP_MEMBERSHIP = 15
}
// @generated message type with reflection information, may provide speed optimized methods
class EditorMarker$Type extends MessageType<EditorMarker> {
    constructor() {
        super("c1.api.editor.v1.EditorMarker", [
            { no: 1, name: "startLineNumber", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "startColumn", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "endLineNumber", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "endColumn", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "severity", kind: "enum", T: () => ["c1.api.editor.v1.EditorMarkerSeverity", EditorMarkerSeverity] }
        ]);
    }
    create(value?: PartialMessage<EditorMarker>): EditorMarker {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.startLineNumber = 0;
        message.startColumn = 0;
        message.endLineNumber = 0;
        message.endColumn = 0;
        message.message = "";
        message.severity = 0;
        if (value !== undefined)
            reflectionMergePartial<EditorMarker>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EditorMarker): EditorMarker {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 startLineNumber */ 1:
                    message.startLineNumber = reader.int32();
                    break;
                case /* int32 startColumn */ 2:
                    message.startColumn = reader.int32();
                    break;
                case /* int32 endLineNumber */ 3:
                    message.endLineNumber = reader.int32();
                    break;
                case /* int32 endColumn */ 4:
                    message.endColumn = reader.int32();
                    break;
                case /* string message */ 5:
                    message.message = reader.string();
                    break;
                case /* c1.api.editor.v1.EditorMarkerSeverity severity */ 6:
                    message.severity = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EditorMarker, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 startLineNumber = 1; */
        if (message.startLineNumber !== 0)
            writer.tag(1, WireType.Varint).int32(message.startLineNumber);
        /* int32 startColumn = 2; */
        if (message.startColumn !== 0)
            writer.tag(2, WireType.Varint).int32(message.startColumn);
        /* int32 endLineNumber = 3; */
        if (message.endLineNumber !== 0)
            writer.tag(3, WireType.Varint).int32(message.endLineNumber);
        /* int32 endColumn = 4; */
        if (message.endColumn !== 0)
            writer.tag(4, WireType.Varint).int32(message.endColumn);
        /* string message = 5; */
        if (message.message !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.message);
        /* c1.api.editor.v1.EditorMarkerSeverity severity = 6; */
        if (message.severity !== 0)
            writer.tag(6, WireType.Varint).int32(message.severity);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.editor.v1.EditorMarker
 */
export const EditorMarker = new EditorMarker$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EditorServiceValidateCELRequest$Type extends MessageType<EditorServiceValidateCELRequest> {
    constructor() {
        super("c1.api.editor.v1.EditorServiceValidateCELRequest", [
            { no: 1, name: "expression", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1048576" } } } },
            { no: 2, name: "validation_env", kind: "enum", T: () => ["c1.api.editor.v1.EditorValidationEnv", EditorValidationEnv, "EDITOR_VALIDATION_ENV_"] },
            { no: 3, name: "form_field_context", kind: "message", T: () => FormFieldCELContext },
            { no: 4, name: "workflow_context", kind: "message", T: () => WorkflowCELContext }
        ]);
    }
    create(value?: PartialMessage<EditorServiceValidateCELRequest>): EditorServiceValidateCELRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expression = "";
        message.validationEnv = 0;
        if (value !== undefined)
            reflectionMergePartial<EditorServiceValidateCELRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EditorServiceValidateCELRequest): EditorServiceValidateCELRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string expression */ 1:
                    message.expression = reader.string();
                    break;
                case /* c1.api.editor.v1.EditorValidationEnv validation_env */ 2:
                    message.validationEnv = reader.int32();
                    break;
                case /* c1.api.editor.v1.FormFieldCELContext form_field_context */ 3:
                    message.formFieldContext = FormFieldCELContext.internalBinaryRead(reader, reader.uint32(), options, message.formFieldContext);
                    break;
                case /* c1.api.editor.v1.WorkflowCELContext workflow_context */ 4:
                    message.workflowContext = WorkflowCELContext.internalBinaryRead(reader, reader.uint32(), options, message.workflowContext);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EditorServiceValidateCELRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string expression = 1; */
        if (message.expression !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.expression);
        /* c1.api.editor.v1.EditorValidationEnv validation_env = 2; */
        if (message.validationEnv !== 0)
            writer.tag(2, WireType.Varint).int32(message.validationEnv);
        /* c1.api.editor.v1.FormFieldCELContext form_field_context = 3; */
        if (message.formFieldContext)
            FormFieldCELContext.internalBinaryWrite(message.formFieldContext, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.editor.v1.WorkflowCELContext workflow_context = 4; */
        if (message.workflowContext)
            WorkflowCELContext.internalBinaryWrite(message.workflowContext, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.editor.v1.EditorServiceValidateCELRequest
 */
export const EditorServiceValidateCELRequest = new EditorServiceValidateCELRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EditorServiceValidateCELResponse$Type extends MessageType<EditorServiceValidateCELResponse> {
    constructor() {
        super("c1.api.editor.v1.EditorServiceValidateCELResponse", [
            { no: 2, name: "markers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => EditorMarker }
        ]);
    }
    create(value?: PartialMessage<EditorServiceValidateCELResponse>): EditorServiceValidateCELResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.markers = [];
        if (value !== undefined)
            reflectionMergePartial<EditorServiceValidateCELResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EditorServiceValidateCELResponse): EditorServiceValidateCELResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.editor.v1.EditorMarker markers */ 2:
                    message.markers.push(EditorMarker.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EditorServiceValidateCELResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.editor.v1.EditorMarker markers = 2; */
        for (let i = 0; i < message.markers.length; i++)
            EditorMarker.internalBinaryWrite(message.markers[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.editor.v1.EditorServiceValidateCELResponse
 */
export const EditorServiceValidateCELResponse = new EditorServiceValidateCELResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkflowCELContext$Type extends MessageType<WorkflowCELContext> {
    constructor() {
        super("c1.api.editor.v1.WorkflowCELContext", [
            { no: 1, name: "trigger_type", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "preceding_step_names", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "current_step_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<WorkflowCELContext>): WorkflowCELContext {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.triggerType = 0;
        message.precedingStepNames = [];
        message.currentStepName = "";
        if (value !== undefined)
            reflectionMergePartial<WorkflowCELContext>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkflowCELContext): WorkflowCELContext {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 trigger_type */ 1:
                    message.triggerType = reader.int32();
                    break;
                case /* repeated string preceding_step_names */ 2:
                    message.precedingStepNames.push(reader.string());
                    break;
                case /* string current_step_name */ 3:
                    message.currentStepName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkflowCELContext, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 trigger_type = 1; */
        if (message.triggerType !== 0)
            writer.tag(1, WireType.Varint).int32(message.triggerType);
        /* repeated string preceding_step_names = 2; */
        for (let i = 0; i < message.precedingStepNames.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.precedingStepNames[i]);
        /* string current_step_name = 3; */
        if (message.currentStepName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.currentStepName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.editor.v1.WorkflowCELContext
 */
export const WorkflowCELContext = new WorkflowCELContext$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormFieldCELContext$Type extends MessageType<FormFieldCELContext> {
    constructor() {
        super("c1.api.editor.v1.FormFieldCELContext", [
            { no: 1, name: "field_types", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "validate.rules": { map: { keys: { string: { minLen: "1" } }, values: { string: { minLen: "1" } } } } } },
            { no: 2, name: "current_field_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<FormFieldCELContext>): FormFieldCELContext {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fieldTypes = {};
        message.currentFieldName = "";
        if (value !== undefined)
            reflectionMergePartial<FormFieldCELContext>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FormFieldCELContext): FormFieldCELContext {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* map<string, string> field_types */ 1:
                    this.binaryReadMap1(message.fieldTypes, reader, options);
                    break;
                case /* string current_field_name */ 2:
                    message.currentFieldName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap1(map: FormFieldCELContext["fieldTypes"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof FormFieldCELContext["fieldTypes"] | undefined, val: FormFieldCELContext["fieldTypes"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.editor.v1.FormFieldCELContext.field_types");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: FormFieldCELContext, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* map<string, string> field_types = 1; */
        for (let k of globalThis.Object.keys(message.fieldTypes))
            writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.fieldTypes[k]).join();
        /* string current_field_name = 2; */
        if (message.currentFieldName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.currentFieldName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.editor.v1.FormFieldCELContext
 */
export const FormFieldCELContext = new FormFieldCELContext$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EditorServiceGetCELSchemaRequest$Type extends MessageType<EditorServiceGetCELSchemaRequest> {
    constructor() {
        super("c1.api.editor.v1.EditorServiceGetCELSchemaRequest", [
            { no: 1, name: "validation_env", kind: "enum", T: () => ["c1.api.editor.v1.EditorValidationEnv", EditorValidationEnv, "EDITOR_VALIDATION_ENV_"] },
            { no: 2, name: "workflow_context", kind: "message", T: () => WorkflowCELContext },
            { no: 3, name: "form_field_context", kind: "message", T: () => FormFieldCELContext }
        ]);
    }
    create(value?: PartialMessage<EditorServiceGetCELSchemaRequest>): EditorServiceGetCELSchemaRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.validationEnv = 0;
        if (value !== undefined)
            reflectionMergePartial<EditorServiceGetCELSchemaRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EditorServiceGetCELSchemaRequest): EditorServiceGetCELSchemaRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.editor.v1.EditorValidationEnv validation_env */ 1:
                    message.validationEnv = reader.int32();
                    break;
                case /* c1.api.editor.v1.WorkflowCELContext workflow_context */ 2:
                    message.workflowContext = WorkflowCELContext.internalBinaryRead(reader, reader.uint32(), options, message.workflowContext);
                    break;
                case /* c1.api.editor.v1.FormFieldCELContext form_field_context */ 3:
                    message.formFieldContext = FormFieldCELContext.internalBinaryRead(reader, reader.uint32(), options, message.formFieldContext);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EditorServiceGetCELSchemaRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.editor.v1.EditorValidationEnv validation_env = 1; */
        if (message.validationEnv !== 0)
            writer.tag(1, WireType.Varint).int32(message.validationEnv);
        /* c1.api.editor.v1.WorkflowCELContext workflow_context = 2; */
        if (message.workflowContext)
            WorkflowCELContext.internalBinaryWrite(message.workflowContext, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.editor.v1.FormFieldCELContext form_field_context = 3; */
        if (message.formFieldContext)
            FormFieldCELContext.internalBinaryWrite(message.formFieldContext, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.editor.v1.EditorServiceGetCELSchemaRequest
 */
export const EditorServiceGetCELSchemaRequest = new EditorServiceGetCELSchemaRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EditorServiceGetCELSchemaResponse$Type extends MessageType<EditorServiceGetCELSchemaResponse> {
    constructor() {
        super("c1.api.editor.v1.EditorServiceGetCELSchemaResponse", [
            { no: 1, name: "variables", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CELVariable },
            { no: 2, name: "functions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CELFunction },
            { no: 3, name: "types", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CELType },
            { no: 4, name: "constants", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CELConstant }
        ]);
    }
    create(value?: PartialMessage<EditorServiceGetCELSchemaResponse>): EditorServiceGetCELSchemaResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.variables = [];
        message.functions = [];
        message.types = [];
        message.constants = [];
        if (value !== undefined)
            reflectionMergePartial<EditorServiceGetCELSchemaResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EditorServiceGetCELSchemaResponse): EditorServiceGetCELSchemaResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.editor.v1.CELVariable variables */ 1:
                    message.variables.push(CELVariable.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.editor.v1.CELFunction functions */ 2:
                    message.functions.push(CELFunction.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.editor.v1.CELType types */ 3:
                    message.types.push(CELType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.editor.v1.CELConstant constants */ 4:
                    message.constants.push(CELConstant.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EditorServiceGetCELSchemaResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.editor.v1.CELVariable variables = 1; */
        for (let i = 0; i < message.variables.length; i++)
            CELVariable.internalBinaryWrite(message.variables[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.editor.v1.CELFunction functions = 2; */
        for (let i = 0; i < message.functions.length; i++)
            CELFunction.internalBinaryWrite(message.functions[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.editor.v1.CELType types = 3; */
        for (let i = 0; i < message.types.length; i++)
            CELType.internalBinaryWrite(message.types[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.editor.v1.CELConstant constants = 4; */
        for (let i = 0; i < message.constants.length; i++)
            CELConstant.internalBinaryWrite(message.constants[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.editor.v1.EditorServiceGetCELSchemaResponse
 */
export const EditorServiceGetCELSchemaResponse = new EditorServiceGetCELSchemaResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CELVariable$Type extends MessageType<CELVariable> {
    constructor() {
        super("c1.api.editor.v1.CELVariable", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CELVariable>): CELVariable {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.typeName = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<CELVariable>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CELVariable): CELVariable {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string type_name */ 2:
                    message.typeName = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CELVariable, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string type_name = 2; */
        if (message.typeName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.typeName);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.editor.v1.CELVariable
 */
export const CELVariable = new CELVariable$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CELFunction$Type extends MessageType<CELFunction> {
    constructor() {
        super("c1.api.editor.v1.CELFunction", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "param_types", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "return_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CELFunction>): CELFunction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.description = "";
        message.paramTypes = [];
        message.returnType = "";
        if (value !== undefined)
            reflectionMergePartial<CELFunction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CELFunction): CELFunction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* repeated string param_types */ 3:
                    message.paramTypes.push(reader.string());
                    break;
                case /* string return_type */ 4:
                    message.returnType = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CELFunction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* repeated string param_types = 3; */
        for (let i = 0; i < message.paramTypes.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.paramTypes[i]);
        /* string return_type = 4; */
        if (message.returnType !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.returnType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.editor.v1.CELFunction
 */
export const CELFunction = new CELFunction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CELType$Type extends MessageType<CELType> {
    constructor() {
        super("c1.api.editor.v1.CELType", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CELTypeField }
        ]);
    }
    create(value?: PartialMessage<CELType>): CELType {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.description = "";
        message.fields = [];
        if (value !== undefined)
            reflectionMergePartial<CELType>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CELType): CELType {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* repeated c1.api.editor.v1.CELTypeField fields */ 3:
                    message.fields.push(CELTypeField.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CELType, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* repeated c1.api.editor.v1.CELTypeField fields = 3; */
        for (let i = 0; i < message.fields.length; i++)
            CELTypeField.internalBinaryWrite(message.fields[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.editor.v1.CELType
 */
export const CELType = new CELType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CELTypeField$Type extends MessageType<CELTypeField> {
    constructor() {
        super("c1.api.editor.v1.CELTypeField", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CELTypeField>): CELTypeField {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.typeName = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<CELTypeField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CELTypeField): CELTypeField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string type_name */ 2:
                    message.typeName = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CELTypeField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string type_name = 2; */
        if (message.typeName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.typeName);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.editor.v1.CELTypeField
 */
export const CELTypeField = new CELTypeField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CELConstant$Type extends MessageType<CELConstant> {
    constructor() {
        super("c1.api.editor.v1.CELConstant", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CELConstant>): CELConstant {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.typeName = "";
        message.value = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<CELConstant>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CELConstant): CELConstant {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string type_name */ 2:
                    message.typeName = reader.string();
                    break;
                case /* string value */ 3:
                    message.value = reader.string();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CELConstant, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string type_name = 2; */
        if (message.typeName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.typeName);
        /* string value = 3; */
        if (message.value !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.value);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.editor.v1.CELConstant
 */
export const CELConstant = new CELConstant$Type();
/**
 * @generated ServiceType for protobuf service c1.api.editor.v1.EditorService
 */
export const EditorService = new ServiceType("c1.api.editor.v1.EditorService", [
    { name: "ValidateCEL", options: { "authz.method": { role: "VIEWER" } }, I: EditorServiceValidateCELRequest, O: EditorServiceValidateCELResponse },
    { name: "GetCELSchema", options: { "authz.method": { role: "VIEWER" } }, I: EditorServiceGetCELSchemaRequest, O: EditorServiceGetCELSchemaResponse }
]);
